import { createWebHistory, createRouter } from 'vue-router'
/* Layout */
import Layout from '@/layout'
import EmptyLayout from "@/layout/emptyLayout.vue";
import TrainLayout from '@/layout/trainLayout.vue';
import StudyCenter from '@/views/studyCenter';
import examMain from '@/views/examCenter/common/examMain.vue'
import examMainAccounting from '@/views/examCenter/common/examMainAccounting.vue'
import questionBank from '@/views/questionBank/index.vue'
import { experienceRouters } from './experienceAccount'
import { videoRouters } from './userPlay'
import { examinationCentreRoters } from './examinationCentre'
import { sysRouters } from './sys'
import { h5Routes } from './h5'
import {frontWebRoutes} from "@/router/frontWeb.js";
/*
 * 基本路由
 */
export const baseRoutes = [
    {
        path: '/',
        component: () => import('@/views/home'),
        hidden: true
    },
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('@/views/redirect/index.vue')
            }
        ]
    },
    {
        path: "/:pathMatch(.*)*",
        component: () => import('@/views/error/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () => import('@/views/error/401'),
        hidden: true
    },
    {
        path: '/localLogin',
        component: () => import('@/views/login/dev'),
    },
    /*  {
        path: '',
        component: Layout,
        redirect: '/index',
        children: [
          {
            path: '/index',
            component: () => import('@/views/index'),
            name: 'Index',
            meta: { title: '首页', icon: 'dashboard', affix: true }
          }
        ]
      },*/
]




/*
 * 业务路由
 */
const businessRoutes = [
    { // 学习中心
        path: '/studyCenter',
        name: 'StudyCenter',
        component: StudyCenter,
        children: [
            { // 我的作业
                path: 'myHomework',
                name: 'MyHomework',
                component: () => import('@/views/workExam/homework'),
                meta: {
                    pageBread: ['我的作业'], // 带上pageBread则会自动显示面包屑，不带则不显示。
                }
            },
            { // 模考&练习
                path: 'myMockPractice',
                name: 'MyMockPractice',
                component: () => import('@/views/workExam/mockPractice'),
                meta: {
                    pageBread: ['模考&练习']
                }
            },
            { // 我的考试
                path: 'myExam',
                name: 'MyExam',
                component: () => import('@/views/workExam/exam'),
                meta: {
                    pageBread: ['考试&作业']
                }
            },
            { // 财税实操-用友
                path: 'cssc',
                name: 'CSSC',
                component: () => import('@/views/cssc/index'),
            },
            { // 财税实操-财略
                path: 'csscMain',
                name: 'CsscMain',
                component: () => import('@/views/csscMain/index'),
            },
            { // 结课证书
                path: 'certificate',
                name: 'Certificate',
                component: () => import('@/views/certificateCompletion/index'),
                meta: {
                    pageBread: ['我的结课证书']
                }
            },
             { // 学习中心 旧版
                path: 'courseUser-old',
                name: 'courseUser-old',
                component: () => import('@/views/courseUser/index.vue'),
                meta: {
                    pageBread: ['学习中心']
                }
            },
            { //学习中心
                path: 'courseUser',
                name: 'courseUser',
                component: () => import('@/views/courseUser-v3/layout'),
                meta:{
                    // pageBread:["学习中心"]
                },
                redirect:'/courseUser/index',
                children:[
                    {
                        path: '/courseUser/index',
                        name: 'courseUser-index',
                        component: () => import('@/views/courseUser-v3/index'),
                        meta:{
                            // pageBread:["学习中心"]
                        },
                    },
                    {
                        path: '/courseUser/my-course',
                        name: 'courseUser-my-course',
                        component: () => import('@/views/courseUser-v3/my-course'),
                        meta:{
                            // pageBread:["学习中心","我的课程"]
                        },
                    },
                    {
                        path: '/courseUser/my-course-v3',
                        name: 'courseUser-my-course-v3',
                        component: () => import('@/views/courseUser-v3/my-course'),
                        meta:{
                            // pageBread:["学习中心","我的课程"]
                        },
                    }
                ]
            },
            { //国考
                path: 'guokao-moni',
                name: 'guokao-moni',
                component: () => import('@/views/guoKao/index'),
                meta:{
                    pageBread:["练习&模拟"]
                }
            },
            { //错题记录
                path: 'answerRecord',
                name: 'answerRecord',
                component: () => import('@/views/answerRecord-v2/index.vue'),
                meta:{
                    pageBread:["错题记录"]
                }
            },
            { //训练营工具包
                path: 'trainingCamp',
                name: 'trainingCamp',
                component: () => import('@/views/trainingCamp/index.vue'),
                meta:{
                    pageBread:["训练营工具包"]
                }
            },
            { //答疑月刊
                path: 'questionsMonthly',
                name: 'questionsMonthly',
                component: () => import('@/views/questionsMonthly/index.vue'),
                meta:{
                    pageBread:["答疑月刊"]
                }
            },
            { //我的课表
                path: 'stuSchedule',
                name: 'stuSchedule',
                component: () => import('@/views/stuSchedule/index.vue'),
                meta:{
                    pageBread:["我的课表"]
                }
            },
            {
                path: 'myInformation',
                name: 'myInformation',
                component: () => import('@/views/myInformation/index.vue'),
                meta:{
                    pageBread:["我的资料"]
                }
            },
            { // 订单
                path: 'myOrder',
                name: 'MyOrder',
                component: () => import('@/views/myOrder/index'),
                meta:{
                    pageBread:["我的订单"]
                }
            },
            { // 我的就业
                path: 'myJob',
                name: 'MyJob',
                component: () => import('@/views/myJob/index'),
                meta:{
                    pageBread:["我的就业"]
                }
            },
            { // 新生预科班
                path: 'newStudentStudy',
                name: 'NewStudentStudy',
                component: () => import('@/views/new-student-study/index.vue'),
                meta:{
                    pageBread:["新生预科班"]
                }
            },
            { // 消息中心
                path: 'messageCenter',
                name: 'messageCenter',
                component: () => import('@/views/messageCenter/index.vue'),
                meta:{
                    pageBread:["消息"]
                }
            },
        ]
    },
    { // 结课详情
        path: '/certificateDetail',
        name: 'CertificateDetail',
        component: () => import('@/views/certificateCompletion/detail')
    },
    { // 考试中心
        path: '/examCenterDir',
        name: 'ExamCenterDir',
        component: EmptyLayout,
        redirect: '/examCenterDir/examCenter',
        children: [
            {
                path: 'examCenter',
                name: 'ExamCenter',
                component: () => import('@/views/examCenter/index'),
            },
            { // 通用考试准备页
                path: 'examPrepare',
                name: 'ExamPrepare',
                component: () => import('@/views/examCenter/common/prepare'),
            },
            { // 通用考试--主页面
                path: 'examMain',
                name: 'ExamMain',
                component: examMain,
            },
            { // 通用考试--真账实训
                path: 'examMainAccounting',
                name: 'ExamMainAccounting',
                component: examMainAccounting,
            },
            { // 通用考试--做题解析页
                path: 'examAnalysis',
                name: 'ExamAnalysis',
                component: () => import('@/views/examCenter/common/examAnalysis'),
            },
            { // 做账试卷(财略)--做题解析页
              path: 'examAccountAnalysis',
              name: 'ExamAccountAnalysis',
              component: () => import('@/views/examCenter/common/examAnalysisAccounting'),
            },
            { // 报税题--答案解析页面
                path: 'reportTaxAnalysis',
                name: 'ReportTaxAnalysis',
                component: () => import('@/views/examCenter/reportTax/viewAnalysisDialog'),
                meta: {
                    documentTitle: '报税题-答案解析',
                }
            },
            { // 报税题--答题情况页面
                path: 'reportTaxState',
                name: 'ReportTaxState',
                component: () => import('@/views/examCenter/reportTax/answerStateDialog'),
                meta: {
                    documentTitle: '报税题-答题情况',
                }
            },
            { // 出纳题--答案解析页面
                path: 'cashierAnalysis',
                name: 'CashierAnalysis',
                component: () => import('@/views/examCenter/cashier/viewAnalysisDialog'),
                meta: {
                    documentTitle: '出纳题-答案解析',
                }
            },
            { // 出纳题--答题情况页面
                path: 'cashierState',
                name: 'CashierState',
                component: () => import('@/views/examCenter/cashier/answerStateDialog'),
                meta: {
                    documentTitle: '出纳题-答题情况',
                }
            },
            { // 工商联检--答案解析页面
                path: 'inspectionAnalysis',
                name: 'InspectionAnalysis',
                component: () => import('@/views/examCenter/inspection/result/viewAnalysisDialog'),
                meta: {
                    documentTitle: '工商联检-答案解析',
                }
            },
            { // 工商联检--答题情况页面
                path: 'inspectionState',
                name: 'InspectionState',
                component: () => import('@/views/examCenter/inspection/result/answerStateDialog'),
                meta: {
                    documentTitle: '工商联检-答题情况',
                }
            },
        ]
    },
    {
        //全电发票开票系统
        name: 'DigitalInvoice',
        path: '/digitalInvoice',
        component: TrainLayout,
        redirect: '/digitalInvoice/stateTax/home',
        children: [
            {
                //国家税务总局电子税务局首页
                path: 'stateTax/home',
                name: 'StateTax/home',
                component: () => import('@/views/digitalInvoice/stateTax/home')
            }, {
                //国家税务总局登录页
                path: 'stateTax/login',
                name: 'StateTax/login',
                component: () => import('@/views/digitalInvoice/stateTax/login')
            }, {
                //套餐业务
                path: 'stateTax/package',
                name: 'StateTax/package',
                component: () => import('@/views/digitalInvoice/stateTax/package'),
            },
            {
                //开具专票
                path: 'stateTax/invoice',
                name: 'StateTax/invoice',
                component: () => import('@/views/digitalInvoice/stateTax/invoice'),
            }, {
                //开票信息维护
                path: 'maintence',
                name: 'Maintence',
                component: () => import('@/views/digitalInvoice/maintence/home')
            }, {
                //项目信息维护
                path: 'maintence/spbm',
                name: 'Maintence/spbm',
                component: () => import('@/views/digitalInvoice/maintence/spbm')
            }, {
                //客户信息维护
                path: 'maintence/khbm',
                name: 'Maintence/khbm',
                component: () => import('@/views/digitalInvoice/maintence/khbm')
            }, {
                //蓝字发票开具
                path: 'blueInvoice',
                name: 'BlueInvoice',
                component: () => import('@/views/digitalInvoice/blueInvoice/home')
            }, {
                //蓝字开票——立即开票
                path: 'blueInvoice/invoicing',
                name: 'BlueInvoice/invoicing',
                component: () => import('@/views/digitalInvoice/blueInvoice/invoicing')
            }, {
                //蓝字开票——立即开票
                path: 'blueInvoice/openEnd',
                name: 'BlueInvoice/openEnd',
                component: () => import('@/views/digitalInvoice/blueInvoice/openEnd')
            },
            {
                //红字发票开具
                path: 'redInvoice',
                name: 'RedInvoice',
                component: () => import('@/views/digitalInvoice/redInvoice/home')
            }, {
                //红字发票开具-信息录入
                path: 'redInvoice/enter',
                name: 'RedInvoice/enter',
                component: () => import('@/views/digitalInvoice/redInvoice/enter')
            },
            {
                //红字发票开具-信息确认
                path: 'redInvoice/queren',
                name: 'RedInvoice/queren',
                component: () => import('@/views/digitalInvoice/redInvoice/queren')
            }, {
                //红字发票开具-信息确认
                path: 'redInvoice/kaipiao',
                name: 'RedInvoice/kaipiao',
                component: () => import('@/views/digitalInvoice/redInvoice/kaipiao')
            }
        ]
    },
    { // 常规题--考试
        path: '/regularExam',
        name: 'RegularExam',
        component: EmptyLayout,
        redirect: '/regularExam/examPrepare',
        children: [
            { // 常规题--准备页
                path: 'examPrepare',
                name: 'RegularExamPrepare',
                component: () => import('@/views/regularExam/preparePage'),
            },
            { // 岗前测试--准备页
                path: 'preJobExamPrepare',
                name: 'PreJobExamPrepare',
                component: () => import('@/views/regularExam/preparePreJobPage.vue'),
            },
            { // 常规题-- 做题主页面
                path: 'exam',
                name: 'RegularExamMain',
                component: () => import('@/views/regularExam/examMain'),
            },
            { // 常规题-- 订正错题--单题消灭页面
              path: 'errExerciseExam',
              name: 'ErrExerciseExam',
              component: () => import('@/views/regularExam/examMain/errExerciseExam'),
            },
            { // 常规题--结果页
                path: 'result',
                name: 'RegularExamResult',
                component: () => import('@/views/regularExam/examResult.vue'),
            },
            { // 常规题--预览某个考试的试卷(供CRM白名单查看)
                path: 'previewExam',
                name: 'RegularExamPreviewExam',
                component: () => import('@/views/regularExam/previewExam.vue'),
            },
            { // 常规题--知识点讲解
              path: 'knowledgeExplain',
              name: 'RegularKnowledgeExplain',
              component: () => import('@/views/regularExam/knowledgeExplain.vue'),
            },
        ]
    },
    {
        // 题库
        path: '/questionBank',
        name: 'Questionbank',
        component: questionBank,
        redirect: '/questionBank/index',
        children: [
            { // 常规题--首页
                path: 'index',
                name: 'QuestionbankIndex',
                component: () => import('@/views/questionBank/views/index'),
            },
        ]
    },
    { // 实名认证页
        path: '/realNameAuth',
        name: 'RealNameAuth',
        component: () => import('@/views/realNameAuth/index')
    },
  { // 阿里云--在线预览iframe页面，为了支持多个文档同时打开
    path: '/aliIOfficeRouter',
    name: 'AliIOfficeRouter',
    component: () => import('@/components/OnlineWps/ali/inner/AliIOfficeRouter.vue')
  },
]



export const constantRoutes = baseRoutes.concat(businessRoutes)

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = []
export const baseUrl = '/learning'

const router = createRouter({
    history: createWebHistory(baseUrl),
    routes: [...constantRoutes,...experienceRouters,...videoRouters,...examinationCentreRoters,...sysRouters,...h5Routes,...frontWebRoutes],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
});

export default router;
